import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export const emptyAddr = { street: "", house_number: "", zip: "", city: "", note: "", special: "" };

export const normAddr = (a) => ({ ...emptyAddr, ...(a || {}) });

export default function AddressBlock({ value, onChange, onRemove, removable, prefix, index }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const tid = `${prefix}-${index}`;
  return (
    <div className="rounded-lg border border-border p-3 space-y-3 relative bg-muted/20" data-testid={`trip-address-${tid}`}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold text-muted-foreground">#{index + 1}</span>
        {removable && (
          <Button type="button" size="icon" variant="ghost" className="h-7 w-7 text-red-600" onClick={onRemove} aria-label="Adresse entfernen" data-testid={`trip-remove-${tid}`}>
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div className="col-span-2 sm:col-span-3"><Label className="text-xs">Straße</Label><Input value={value.street || ""} onChange={(e) => set("street", e.target.value)} data-testid={`${tid}-street`} /></div>
        <div className="col-span-1"><Label className="text-xs">Hausnr.</Label><Input value={value.house_number || ""} onChange={(e) => set("house_number", e.target.value)} data-testid={`${tid}-house`} /></div>
        <div className="col-span-1"><Label className="text-xs">PLZ</Label><Input value={value.zip || ""} onChange={(e) => set("zip", e.target.value)} data-testid={`${tid}-zip`} /></div>
        <div className="col-span-2 sm:col-span-3"><Label className="text-xs">Ort</Label><Input value={value.city || ""} onChange={(e) => set("city", e.target.value)} data-testid={`${tid}-city`} /></div>
        <div className="col-span-2"><Label className="text-xs">Bemerkung</Label><Textarea rows={2} value={value.note || ""} onChange={(e) => set("note", e.target.value)} data-testid={`${tid}-note`} /></div>
        <div className="col-span-2"><Label className="text-xs">Besonderheiten</Label><Textarea rows={2} value={value.special || ""} onChange={(e) => set("special", e.target.value)} data-testid={`${tid}-special`} /></div>
      </div>
    </div>
  );
}
